import React, { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import EditPlan from "./edit_plan";
import { OverlayPanel } from "primereact/overlaypanel";
import { api } from "../../../../utility/AxiosInceptor";
import PlansConfigurations from "./plan_configuration";
import { ToastContainer } from "react-toastify";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { toast } from "react-toastify";
import { PlanEditIcon } from "../../../../utility";
import CommonLoaderBlue from "../Prepaid_Updated/Add_Service/components/PaymentScreen/dialog/loader/LoaderBlue";
export default function ListAllPlans() {
  const [overlayContent, setOverlayContent] = useState("");
  const loginRes = localStorage.getItem("userData");
  const parseLoginRes = JSON.parse(loginRes);
  const [refresh, setRefresh] = useState(false);
  const [editPlanVisibility, setEditPlanVisibility] = useState(false);
  const [visible, setVisible] = useState(false);
  const [delteBillingLoader, setDeleteBillingLoader] = useState(false);
  const op = useRef(null);
  const [isSimilarPlan, setIsSimilarPlan] = useState(false);
  const [planList, setPlanList] = useState([]);
  const [loader, setLoader] = useState(true);
  const [rowData, setRowData] = useState(null);
  const [addPlanVisibility, setAddPlanVisibility] = useState(false);
  const statusOverlayRef = useRef(null);
  useEffect(() => {
    const shouldFetchPlans = !editPlanVisibility || !addPlanVisibility;

    if (shouldFetchPlans) {
      setLoader(true);
      api
        .get(`/api/web/plan/all?serviceProvider=${parseLoginRes?.company}`)
        .then((res) => {
          setPlanList(res?.data?.data);
          setLoader(false);
        })
        .catch((err) => {
          setLoader(false);
          // handle error here if needed
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, editPlanVisibility, addPlanVisibility]);
  return (
    <>
      {addPlanVisibility ? (
        <PlansConfigurations
          data={rowData}
          isSimilarPlan={isSimilarPlan}
          setRefresh={setRefresh}
          setAddPlanVisibility={setAddPlanVisibility}
        />
      ) : editPlanVisibility ? (
        <div>
          <EditPlan
            data={rowData}
            setRefresh={setRefresh}
            setEditPlanVisibility={setEditPlanVisibility}
          />
        </div>
      ) : (
        <div className="overflow-hidden flex flex-column planinfomain">
          <ToastContainer />
          <div className="flex  flex-wrap flex-row justify-content-between planheader">
            <div className="flex h-full flex-column justify-content-between">
              <h1>Plan Configuration</h1>
              <p>
                Manage and explore all your plans in one place—add, update, or
                view details with ease.
              </p>{" "}
            </div>
            <div className="flex h-full align-items-end">
              <Button
                onClick={() => {
                  setIsSimilarPlan(false);
                  setAddPlanVisibility(true);
                }}
                className="text-center mr-0 planbtn"
                label="Add Plan"
              />
            </div>
          </div>

          <div className="plantable">
            <DataTable
              emptyMessage={
                loader ? (
                  <div
                    style={{
                      position: "absolute",
                      marginTop: "-1.4rem",
                      width: "108.4rem",
                    }}
                    className="flex flex-wrap justify-content-center align-items-center"
                  >
                    <CommonLoaderBlue color="royalblue" customSize={14} />
                  </div>
                ) : (
                  <p
                    style={{
                      marginTop: "-1rem",
                      position: "absolute",
                      width: "108rem",
                    }}
                  >
                    Plans Not Found
                  </p>
                )
              }
              value={planList}
              size="small"
              stripedRows
              style={{ marginTop: "2.4rem", width: "108.4rem" }}
            >
              <Column header="Plan ID" field="planId" />
              <Column
                header="Name"
                body={(rowData) => {
                  const maxLength = 12;
                  const name = rowData.name;
                  return (
                    <>
                      <p
                        onMouseEnter={(e) => {
                          if (name.length > maxLength) {
                            setOverlayContent(rowData?.name);
                            statusOverlayRef.current.show(e);
                          }
                        }}
                        onMouseLeave={() => statusOverlayRef.current.hide()}
                      >
                        {name.length > maxLength
                          ? name.substring(0, maxLength) + "..."
                          : name}
                      </p>
                      <OverlayPanel ref={statusOverlayRef}>
                        <div
                          style={{ maxwidth: "20rem", padding: "0.5rem 1rem" }}
                        >
                          <p
                            style={{
                              fontWeight: 400,
                              fontSize: "1.4rem",
                              overflow: "hidden",
                              border: "none",
                              margin: "0rem",
                              lineHeight: "1.8rem",
                              color: "#72728f",
                            }}
                          >
                            {" "}
                            {overlayContent}
                          </p>
                        </div>
                      </OverlayPanel>
                    </>
                  );
                }}
              />
              <Column
                header="Inventory Type"
                body={(rowData) => {
                  const maxLength = 17;
                  const inventoryType = rowData.inventoryType;

                  return (
                    <>
                      <p
                        onMouseEnter={(e) => {
                          if (inventoryType.length > maxLength) {
                            setOverlayContent(rowData?.inventoryType);
                            statusOverlayRef.current.show(e);
                          }
                        }}
                        onMouseLeave={() => statusOverlayRef.current.hide()}
                      >
                        {inventoryType.length > maxLength
                          ? inventoryType.substring(0, maxLength) + "..."
                          : inventoryType}
                      </p>
                      <OverlayPanel ref={statusOverlayRef}>
                        <div
                          style={{ maxwidth: "20rem", padding: "0.5rem 1rem" }}
                        >
                          <p
                            style={{
                              fontWeight: 400,
                              fontSize: "1.4rem",
                              overflow: "hidden",
                              border: "none",
                              margin: "0rem",
                              lineHeight: "1.8rem",
                              color: "#72728f",
                              borderRadius: "0.8rem",
                            }}
                          >
                            {" "}
                            {overlayContent}
                          </p>
                        </div>
                      </OverlayPanel>
                    </>
                  );
                }}
                // field="inventoryType"
              />
              <Column header="Billing Model" field="type" />
              <Column header="Text Allowance" field="textAllowance" />
              <Column header="Data Allowance" field="dataAllowance" />
              <Column header="Voice Allowance" field="voiceAllowance" />
              <Column header="Voice Retail Price" field="price" />
              <Column
                header="Description"
                body={(rowData) => {
                  const maxLength = 15;
                  const description = rowData.description;
                  return (
                    <>
                      <p
                        onMouseEnter={(e) => {
                          if (description.length > maxLength) {
                            setOverlayContent(rowData?.description);
                            statusOverlayRef.current.show(e);
                          }
                        }}
                        onMouseLeave={() => statusOverlayRef.current.hide()}
                      >
                        {description.length > maxLength
                          ? description.substring(0, maxLength) + "..."
                          : description}
                      </p>
                      <OverlayPanel ref={statusOverlayRef}>
                        <div
                          style={{ maxWidth: "20rem", padding: "0.5rem 1rem" }}
                        >
                          <p
                            style={{
                              fontWeight: 400,
                              fontSize: "1.4rem",
                              overflow: "hidden",
                              border: "none",
                              margin: "0rem",
                              lineHeight: "1.8rem",
                              color: "#72728f",
                            }}
                          >
                            {" "}
                            {overlayContent}
                          </p>
                        </div>
                      </OverlayPanel>
                    </>
                  );
                }}
              />
              <Column
                header="Action"
                className="flex justify-content-center"
                body={(rowData) => {
                  return (
                    <>
                      <div
                        className="actionbtnmain"
                        onClick={(e) => {
                          op.current.toggle(e);
                          setRowData(rowData);
                        }}
                        style={{ marginLeft: "1rem" }}
                      >
                        <PlanEditIcon />
                      </div>
                      <OverlayPanel
                        ref={op}
                        style={{ width: "13.3rem", height: "11.2rem" }}
                        className="flex align-items-center planlist"
                      >
                        <div className="flex flex-column w-full overlay">
                          <div
                            className="flex justify-content-start align-items-center prospectoverlay"
                            style={{ height: "3.2rem", width: "13.1rem" }}
                            onClick={() => {
                              setEditPlanVisibility(true);
                            }}
                          >
                            <label
                              style={{ fontSize: "1.2rem", fontWeight: "500" }}
                            >
                              Update
                            </label>
                          </div>
                          <div
                            className="flex justify-content-start align-items-center prospectoverlay"
                            style={{ height: "3.2rem", width: "13.1rem" }}
                            onClick={() => {
                              setVisible(true);
                            }}
                          >
                            <label
                              style={{ fontSize: "1.2rem", fontWeight: "500" }}
                            >
                              Delete
                            </label>
                          </div>
                          <div
                            className="flex justify-content-start align-items-center prospectoverlay"
                            style={{ height: "3.2rem", width: "13.1rem" }}
                            onClick={() => {
                              setIsSimilarPlan(true);

                              setAddPlanVisibility(true);
                            }}
                          >
                            <label
                              style={{ fontSize: "1.2rem", fontWeight: "500" }}
                            >
                              Create Similar Plan
                            </label>
                          </div>
                        </div>
                      </OverlayPanel>
                    </>
                  );
                }}
                field="Edit"
              />
            </DataTable>
          </div>
        </div>
      )}
      <Dialog
        headerClassName="dialogheader"
        closable={false}
        visible={visible}
        onHide={() => {
          if (!visible) return;
          setVisible(false);
        }}
        className="delete-dialog"
      >
        <div className="datadelete">
          <h1>Confirm Deletion</h1>
          <p>
            {" "}
            Are you sure you want to delete this plan? This action cannot be
            undone. Proceed with caution.
          </p>{" "}
        </div>
        <div></div>
        <div className="deletedialogbtn">
          <Button
            className="backbtn"
            label="Cancel"
            onClick={() => setVisible(false)}
            style={{ width: "16rem", height: "5rem" }}
          />
          <Button
            label="Delete"
            className="nextbtn"
            loading={delteBillingLoader}
            disabled={delteBillingLoader}
            onClick={() => {
              setDeleteBillingLoader(true);
              api
                .patch(`/api/web/plan/updateStatus`, {
                  updatedBy: parseLoginRes._id,
                  serviceProvider: parseLoginRes.company,
                  id: rowData._id,
                  status: false,
                })
                .then((res) => {
                  toast.success("Plan Removed Successfully");
                  setDeleteBillingLoader(false);
                  setRefresh((prev) => !prev);
                  setTimeout(() => {
                    setVisible(false);
                  }, 500);
                })
                .catch((err) => {
                  setDeleteBillingLoader(false);
                  toast.error("Plan Removal Failed");
                });
              setVisible(false);
            }}
            style={{ width: "16rem", height: "5rem" }}
          />
        </div>
      </Dialog>
    </>
  );
}
